import React from "react";
import MediaGrid from "./MediaGrid";

export default function FeedMediaComposer({
  mediaFiles,
  mediaPreview,
  uploadProgress,
  isPosting,
  onSelectMedia,
  showProgress = false,
}) {
  /* one progress bar per tile, drawn inside that tile by MediaGrid */
  const renderOverlay = (i) => {
    if (!showProgress) return null;

    const file = mediaFiles[i];
    const key = file ? `${file.name}-${file.size}` : null;
    const progress = key ? uploadProgress?.[key] : null;

    if (typeof progress !== "number" || progress >= 100) return null;

    return (
      <div className="absolute inset-x-0 bottom-0 h-1 bg-neutral-300/70 overflow-hidden z-10">
        <div
          className="h-1 bg-blue-500 transition-all duration-150"
          style={{ width: `${progress}%` }}
        />
      </div>
    );
  };

  return (
    <>
      {/* MEDIA PICKER */}
      <div className="mt-2 flex items-center gap-3">
        <label
          htmlFor="feed-media-composer-input" // ✅ CONNECT LABEL
          className={`cursor-pointer text-sm font-medium ${
            mediaFiles.length >= 4
              ? "text-neutral-400 cursor-not-allowed"
              : "text-blue-500"
          }`}
        >
          📎 Media ({mediaFiles.length}/4)
        </label>

        <input
          id="feed-media-composer-input"   // ✅ ADD
          name="feed-media-composer"       // ✅ ADD
          type="file"
          accept="image/*,video/*"
          multiple
          hidden
          disabled={mediaFiles.length >= 4 || isPosting}
          onChange={onSelectMedia}
        />
      </div>

      {/* MEDIA PREVIEW — same layout as the feed, so what you see is what gets posted */}
      {mediaPreview.length > 0 && (
        <div className="relative">
          <MediaGrid media={mediaPreview} renderOverlay={renderOverlay} />
        </div>
      )}
    </>
  );
}